/**
Project: Voice Panel (c)
Title: Table Pagination
Description: Component for displaying the table pagination
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import {
  Flex,
  Button,
  Dropdown,
  ChevronStartIcon,
  ChevronEndIcon,
} from "@fluentui/react-northstar";
import classNames from "classnames";
import IntlUtil from "../../../../core/helpers/intl-util";
import { VoiceAdminConstants } from "../settings/voice-admin-constants";

class TablePagination extends Component {
  _intl_ns_vpa_common = "vpa_common";

  constructor(props) {
    super(props);
    this.state = {
      showPaginationControls: false,
      pageLimitOptions: VoiceAdminConstants.TABLE_DATA.PAGE_LIMIT_OPTIONS,
    };
  }

  togglePaginationControls = (value) => {
    this.setState({ showPaginationControls: value });
  };

  handlePageOffsetChange = (pageOffset) => {
    if (pageOffset >= 0) {
      this.props.handlePageOffsetChange(pageOffset);
    }
  };

  handlePageLimitChange = (pageLimit) => {
    if (pageLimit > 0) {
      this.props.handlePageLimitChange(pageLimit);
      this.togglePaginationControls(false);
    }
  };

  render() {
    if (this.props.totalRecords) {
      let pageOffset = this.props.pageOffset;
      const pageLimit = this.props.pageLimit;
      //const recordCount = this.props.recordCount;
      const totalRecords = this.props.totalRecords;
      let pageCount = Math.ceil(totalRecords / pageLimit);

      if (pageOffset < 0 || pageOffset > pageCount - 1) {
        pageOffset = 0;
      }

      const firstItemDisableStatus = pageOffset === 0 ? true : false;
      const firstItemClickCallback = () => this.handlePageOffsetChange(0);

      const lastItemDisableStatus = pageOffset === pageCount - 1 ? true : false;
      const lastItemClickCallback = () =>
        this.handlePageOffsetChange(pageCount - 1);

      const previousItemDisableStatus = pageOffset === 0 ? true : false;
      const previousItemClickCallback = () =>
        this.handlePageOffsetChange(pageOffset - 1);

      const nextItemDisableStatus = pageOffset === pageCount - 1 ? true : false;
      const nextItemClickCallback = () =>
        this.handlePageOffsetChange(pageOffset + 1);

      /*
      let pageNumArray = [];
      if (pageCount <= 5) {
        for (let i = 1; i <= pageCount; i++) {
          pageNumArray.push(i);
        }
      } else if (pageCount > 5 && pageCount <= 10) {
        for (let j = 1; j <= 2; j++) {
          pageNumArray.push(j);
        }
        for (let k = pageCount - 1; k <= pageCount; k++) {
          pageNumArray.push(k);
        }
      } else {
        let midNum1 = parseInt(pageCount / 2);
        let midNum2 = parseInt(midNum1 + 1);
        let firstNum = parseInt(midNum1 / 2);
        let lastNum = parseInt(midNum2 + midNum2 / 2);
        pageNumArray.push(firstNum);
        pageNumArray.push(midNum1);
        pageNumArray.push(midNum2);
        pageNumArray.push(lastNum);
      }
      */
      const doubleArrowStyle = {
        width: "7px",
      };

      return (
        <Flex
          onMouseEnter={() => this.togglePaginationControls(true)}
          onMouseLeave={() => this.togglePaginationControls(false)}
          className={classNames(
            "border-w-1",
            { "border-c-transparent": !this.state.showPaginationControls },
            {
              "bg-white border-c-primary-fade":
                this.state.showPaginationControls,
            }
          )}
        >
          {this.state.showPaginationControls ? (
            <Dropdown
              fluid
              inverted
              //placeholder="Records per Page"
              items={this.state.pageLimitOptions}
              defaultValue={this.props.pageLimit}
              getA11ySelectionMessage={{
                onAdd: (item) => {
                  this.handlePageLimitChange(item);
                },
              }}
              defaultOpen={false}
              position="below"
              className="page-dropdown"
              title={IntlUtil.getText(
                this._intl_ns_vpa_common,
                "content.recordsPerPage"
              )}
            />
          ) : null}
          <Button
            text
            iconOnly
            icon={
              <>
                <ChevronStartIcon style={doubleArrowStyle} />
                <ChevronStartIcon />
              </>
            }
            disabled={firstItemDisableStatus}
            title={IntlUtil.getText(
              this._intl_ns_vpa_common,
              "content.firstPage"
            )}
            onClick={firstItemClickCallback}
          ></Button>
          <Button
            text
            iconOnly
            icon={<ChevronStartIcon />}
            disabled={previousItemDisableStatus}
            title={IntlUtil.getText(
              this._intl_ns_vpa_common,
              "content.previousPage"
            )}
            onClick={previousItemClickCallback}
          ></Button>
          {/*pageNumArray.map((element) => {
            
            let pageItemEnableStatus =
              element - 1 === pageOffset ? true : false;
            return (
              <Button
                iconOnly
                active={pageItemEnableStatus}
                key={`msrp-${element}`}
                title={`Page ${element}`}
                onClick={() => this.handlePageOffsetChange(element - 1)}
              >
                <Text
                  content={element}
                  className={classNames(
                    {
                      "page-list-pagination-link-active":
                        pageItemEnableStatus === true,
                    },
                    {
                      "page-list-pagination-link-inactive":
                        pageItemEnableStatus === false,
                    }
                  )}
                />
              </Button>
            );
          })*/}
          <Button
            text
            iconOnly
            icon={<ChevronEndIcon />}
            disabled={nextItemDisableStatus}
            title={IntlUtil.getText(
              this._intl_ns_vpa_common,
              "content.nextPage"
            )}
            onClick={nextItemClickCallback}
          ></Button>
          <Button
            text
            iconOnly
            icon={
              <>
                <ChevronEndIcon style={doubleArrowStyle} />
                <ChevronEndIcon />
              </>
            }
            disabled={lastItemDisableStatus}
            title={IntlUtil.getText(
              this._intl_ns_vpa_common,
              "content.lastPage"
            )}
            onClick={lastItemClickCallback}
          ></Button>
        </Flex>
      );
    } else {
      return null;
    }
  }
}

export default TablePagination;
